"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcalendarandplus = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcalendarandplus` : '') + (description ? ` desc-brandedcalendarandplus` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcalendarandplus"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcalendarandplus"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 17H52V51C52 52.6569 50.6569 54 49 54H3C1.34314 54 0 52.6569 0 51V17Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.5714 17H42C33.5 33.9725 22.0536 46.3191 4.2506 53.5008L3 54H49C50.6569 54 52 52.6569 52 51V17C52 17 46.4179 17 44.5714 17Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "4",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "4",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "28",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "40",
    y: "23",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "40",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "28",
    y: "37",
    width: "8",
    height: "8",
    rx: "1",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44 57C50.6274 57 56 51.6274 56 45C56 38.3726 50.6274 33 44 33C37.3726 33 32 38.3726 32 45C32 51.6274 37.3726 57 44 57Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.7165 37.1576C56.0427 41.4136 56.1022 48.378 51.8455 52.7134C47.5888 57.0488 40.6233 57.0984 36.2872 52.8424C31.951 48.5864 31.9014 41.622 36.1582 37.2866C40.4149 32.9512 47.3903 32.9016 51.7165 37.1576Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.0035 38.0201C44.7826 38.0312 45.4213 38.6578 45.4204 39.4246L45.417 50.6276C45.4059 51.4042 44.7696 52.0225 43.9904 52.0213C43.2114 52.0102 42.5726 51.3836 42.5735 50.6168L42.5769 39.4139C42.588 38.6372 43.2243 38.0189 44.0035 38.0201Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.0128 44.9908C37.0058 45.7873 37.6378 46.4445 38.4151 46.441L49.6153 46.4459C50.3925 46.4527 51.016 45.7961 51.0131 44.9892C51.0201 44.1927 50.3881 43.5355 49.6108 43.5391L38.4106 43.5342C37.6335 43.5274 37.0099 44.184 37.0128 44.9908Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 5.3125H30V7.85796C30 10.0671 28.2091 11.858 26 11.858C23.7909 11.858 22 10.0671 22 7.85795V5.3125H14V7.85796C14 10.0671 12.2091 11.858 10 11.858C7.79086 11.858 6 10.0671 6 7.85795V5.3125H3C1.34315 5.3125 0 6.65565 0 8.3125V17.3125H52V8.3125C52 6.65565 50.6569 5.3125 49 5.3125H45V7.85796C45 10.0671 43.2091 11.858 41 11.858C38.7909 11.858 37 10.0671 37 7.85795V5.3125Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "38.5006",
    width: "5",
    height: "11",
    rx: "2.5",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "23.5004",
    width: "5",
    height: "11",
    rx: "2.5",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "7.50061",
    width: "5",
    height: "11",
    rx: "2.5",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedcalendarandplus;